import { render } from "./ModalFooter.vue?vue&type=template&id=5269c769&lang=pug"
import script from "./ModalFooter.vue?vue&type=script&lang=js"
export * from "./ModalFooter.vue?vue&type=script&lang=js"

import "./ModalFooter.vue?vue&type=style&index=0&id=5269c769&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__